import { useState } from "react";
import { Check, ChevronDown, Tag } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export default function StickerPrintMenu({ count, disabled, onPrint }) {
  const [designs, setDesigns] = useState(null);
  const current = localStorage.getItem("sticker-design") || "";
  const load = (open) => open && api.get("/branding/sticker-designs").then((r) => setDesigns(r.data)).catch(() => setDesigns([]));
  const pick = (id) => { localStorage.setItem("sticker-design", id); onPrint(); };
  const Item = ({ id, name }) => (
    <DropdownMenuItem onSelect={() => pick(id)} data-testid={`sticker-layout-${id || "standard"}`}>
      <Check size={14} className={current === id ? "opacity-100" : "opacity-0"} /> {name}
    </DropdownMenuItem>
  );
  return (
    <DropdownMenu onOpenChange={load}>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" disabled={disabled} data-testid="print-stickers-button" className="hover:bg-secondary hover:text-foreground">
          <Tag size={16} /> Print stickers{count ? ` (${count})` : ""} <ChevronDown size={14} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-card w-60" data-testid="sticker-layout-menu">
        <DropdownMenuLabel className="text-xs text-muted-foreground">Choose a sticker layout</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <Item id="" name="Standard sticker" />
        {designs === null ? <p className="px-2 py-1.5 text-xs text-muted-foreground">Loading designs…</p>
          : designs.map((d) => <Item key={d.id} id={d.id} name={d.name} />)}
        {designs?.length === 0 && <p className="px-2 py-1.5 text-xs text-muted-foreground">No saved designs yet — make one on the Stickers page.</p>}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
